import Blog1 from "./BlogContent1";
import Blog2 from "./BlogContent2";
import Blog3 from "./BlogContent3";
import Blog4 from "./BlogContent4";
import img1 from "../Images/Konn3ct Images/Decision.jpg";
import img2 from "../Images/Konn3ct Images/Rectangle 3 (1).png";


const blogPosts = [
  {
    id: 1,
    title: "Getting Started with Konn3ct App",
    category: "Education",
    date: "August 22, 2025",
    readTime: "4 min read",
    author: "Oloruntola Ayodeji",
    authorRole: "Content Writer, Konn3ct",
    authorAvatar: "/avatar-sarah.jpg",
    description:"In today's fast-paced digital world, video conferencing tools have become essential for seamless communication. Whether you're connecting with colleagues, hosting a webinar, or conducting an online class, Konn3ct is your go-to solution for high-quality video meetings. In this guide, we'll walk you through how to use Konn3ct effectively and make the most of its features.",
    image: img1,
    content: <Blog1 />, 
  },
  {
    id: 2,
    title: "Using Konn3ct for Seamless Video Meetings",
    category: "How To" ,
    date: "March 15, 2025",
    readTime: "4 min read",
    author: "Lukman Adewuyi",
    authorRole: "Content Writer, Konn3ct",
    authorAvatar: "/avatar-sarah.jpg",
    description:
      "Staying connected is critical in today's world, Whether you’re hosting a webinar, conducting a business meeting, or connecting with friends and family, having a reliable video conferencing tool makes all the difference. Konn3ct is an indigenous Nigerian platform designed to make video meetings accessible, affordable, and feature-rich for individuals and businesses.",
    image: img2,
    content: <Blog2 /> , 
  },
  
  {
    id: 3,
    title: "Creating and Managing Meeting Rooms on Konn3ct",
    category: "Education",
    date: "March 5, 2025",
    readTime: "4 min read",
    author: "Oloruntola Ayodeji",
    authorRole: "Content Writer, Konn3ct",
    authorAvatar: "/avatar-sarah.jpg",
    description: "Video conferencing is a cornerstone of modern communication, and Konn3ct, an innovative platform designed for seamless online collaboration, offers users a range of tools for creating and managing meeting rooms.",
        image: img1,
    content: <Blog3 />, 
  },
  {
    id: 4,
    title: "How to Join Breakout Rooms on Konn3ct",
    category: "How To",
    date: "March 15, 2025",
    readTime: "4 min read",
    author: "Lukman Adewuyi",
    authorRole: "Content Writer, Konn3ct",
    authorAvatar: "/avatar-sarah.jpg",
    description:
      "Breakout rooms are a powerful feature for managing online meetings, conferences, and events. They allow hosts to divide participants into smaller, focused groups, enabling personalized interactions and discussions. ",
    image: img1,
    content: <Blog4 />, 
  },
  // {
  //   id: 5,
  //   title: "Implementing Odoo ERP for Pharma-Business in Nigeria",
  //   category: "Konn3ct AI",
  //   date: "March 15, 2025",
  //   readTime: "4 min read",
  //   author: "Oloruntola Ayodeji",
  //   authorRole: "Content Writer, Konn3ct",
  //   authorAvatar: "/avatar-sarah.jpg",
  //   description:
  //     "Discover how Odoo ERP helps Nigerian pharmaceutical companies meet NAFDAC regulations with full traceability, quality control, and audit-ready systems.",
  //   image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1400&q=80",
  //   content: <Post1Content />, 
  // },
  // {
  //   id: 6,
  //   title: "Implementing Odoo ERP for Pharma-Business in Nigeria",
  //   category: "Education",
  //   date: "March 15, 2025",
  //   readTime: "12 min read",
  //   author: "Oloruntola Ayodeji",
  //   authorRole: "Content Writer, Konn3ct",
  //   authorAvatar: "/avatar-sarah.jpg",
  //   description:
  //     "Discover how Odoo ERP helps Nigerian pharmaceutical companies meet NAFDAC regulations with full traceability, quality control, and audit-ready systems.",
  //   image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1400&q=80",
  //   content: <Post1Content />, 
  // },
  // {
  //   id: 7,
  //   title: "Implementing Odoo ERP for Pharma-Business in Nigeria",
  //   category: "Konn3ct AI",
  //   date: "March 15, 2025",
  //   readTime: "6 min read",
  //   author: "Oloruntola Ayodeji",
  //   authorRole: "Content Writer, Konn3ct",
  //   authorAvatar: "/avatar-sarah.jpg",
  //   description:
  //       "Aenean eleifend ante maecenas pulvinar montes lorem et pede. Aenean eleifend ante maecenas pulvinar montes lorem et pede dictum.",
  //   image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1400&q=80",
  //   content: <Post1Content />, 
  // },
 
   
];

export default blogPosts;


// // src/data/blogPosts.js
// import Blog1Content from "../Components/BlogContent";
// // import Blog2Content from "../Components/BlogContent/Blog2Content";

// export const blogPosts = [
//   {
//     id: 1,
//     title: "Integer Maecenas Eget Viverra",
//     category: "Education",
//     date: "March 15, 2025",
//     readTime: "4 min read",
//     author: "Oloruntola Ayodeji",
//     authorRole: "Content Writer, Konn3ct",
//     image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1400&q=80",
//     Content: Blog1Content,   // ← Renamed from "component"
//   },
//   {
//     id: 2,
//     title: "How Konn3ct is Changing Virtual Learning",
//     category: "How To",
//     date: "March 10, 2025",
//     readTime: "6 min read",
//     author: "Oloruntola Ayodeji",
//     authorRole: "Content Writer, Konn3ct",
//     image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1400",
//     Content: Blog1Content,
//   },
//   // Add more...
// ];
// const blogPosts = [
//   {
//     id: 1,
//     title: "Integer Maecenas Eget Viverra",
//     category: "Education",
//     date: "March 15, 2025",
//     readTime: "4 min read",
//     author: "Oloruntola Ayodeji",
//     authorRole: "Content Writer, Konn3ct",
//     authorAvatar: "/avatar-sarah.jpg",
//     image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1400&q=80", // replace with your img1
//      content: (
//     <>
//       <p className="text-lg leading-relaxed text-gray-700 mb-8">
//         Aenean eleifend ante maecenas pulvinar montes lorem et pede dictum. Vel consequat justo sem. Aenean eleifend ante maecenas pulvinar montes lorem et pede.
//       </p>
//       <p className="text-lg leading-relaxed text-gray-700 mb-8">
//         Vel consequat justo sem aenean eleifend ante maecenas pulvinar montes lorem et pede dictum. Vel consequat justo sem...
//       </p>

//       <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
//         Why This is a Subheading
//       </h2>

//       <p className="text-lg leading-relaxed text-gray-700 mb-8">
//         Vel consequat justo sem aenean eleifend ante maecenas pulvinar montes lorem et pede dictum...
//       </p>

//       <ul className="space-y-4 my-10 text-lg text-gray-700">
//         <li className="flex items-start gap-3">
//           <span className="text-[#1A4699] mt-1">Check</span>
//           <span>Beautiful spacing now works perfectly</span>
//         </li>
//         <li className="flex items-start gap-3">
//           <span className="text-[#1A4699] mt-1">Check</span>
//           <span>Tailwind classes are applied</span>
//         </li>
//       </ul>

//       <p className="text-lg leading-relaxed text-gray-700">
//         This is the proper way to write rich blog content in React + Tailwind.
//       </p>
//     </>
//   ),
//   description:
//       "Aenean eleifend ante maecenas pulvinar montes lorem et pede. Aenean eleifend ante maecenas pulvinar montes lorem et pede dictum.",
 
//   },


// ];




// import event1 from "../Images/Konn3ct Images/Rectangle 6321.png";
// import event2 from "../Images/Konn3ct Images/Rectangle 6322.png";
// import event3 from "../Images/Konn3ct Images/Rectangle 6323.png";
// import event4 from "../Images/Konn3ct Images/Rectangle 6324.png";
// import event5 from "../Images/Konn3ct Images/Rectangle 6321.png";
// import event6 from "../Images/Konn3ct Images/Rectangle 6322.png";
// import event7 from "../Images/Konn3ct Images/Rectangle 6323.png";
// import event8 from "../Images/Konn3ct Images/Rectangle 6324.png";
// import formatEventDates from "../Data/KEventDate"

// export const rawEvents = [
//   {
//     id: 1,
//     title: "Occupational Safety and Health (OSH)",
//     date: "Nov 11, 2025 | 09:00 (UTC+01:00)",
//     location: "Lagos, Nigeria",
//     image: event1,
//     tag: "Hybrid",
//      dateString: "Tuesday, October 7",
//     fullDate: "March 11, 2025 | 09:00 - 16:00 (Africa/Lagos)",
//     organizer: "Lagos State Safety Commission",
//     description:
//       "Occupational Safety and Health (OSH) as a Catalyst for Nation Building, Come join us at the Lagos Oriental Hotel for a day filled with insightful discussions on how OSH can drive nation building. This in-person event will bring together experts in the field to share their knowledge and experiences. Whether you're a seasoned professional or just starting out in the industry, there's something for everyone at this event. Don't miss this opportunity to network, learn, and contribute to the advancement of occupational safety and health in our nation. See you there!"
  
//   },
//   {
//     id: 2,
//     title: "INTO THE NEW FUTURE",
//     date: "Oct 29, 2026 | 19:00 (UTC+01:00)",
//     location: "Abuja, Nigeria",
//     image: event2,
//     tag: "Virtual Seminar",
//      dateString: "Wednesday, October 17",
//     fullDate: "March 11, 2025 | 09:00 - 16:00 (Africa/Lagos)",
//     organizer: "Lagos State Safety Commission",
//     description: ""
//   },
//   {
//     id: 3,
//     title: "Move Big 2025",
//     date: "Nov 17, 2025 | 09:00 (UTC+01:00)",
//     location: "Landmark Centre | Virtual Event",
//     image: event3,
//     tag: "Hybrid",
//      dateString: "Tuesday, October 7",
//     fullDate: "March 11, 2025 | 09:00 - 16:00 (Africa/Lagos)",
//     organizer: "Lagos State Safety Commission",
//     description: ""
//   },
//   {
//     id: 4,
//     title: "MISS COSMO | FINALE",
//     date: "Nov 3, 2025 | 17:00 (UTC+01:00)",
//     location: "Lagos, Nigeria",
//     image: event4,
//     tag: "Hybrid",
//      dateString: "Tuesday, October 7",
//     fullDate: "March 11, 2025 | 09:00 - 16:00 (Africa/Lagos)",
//     organizer: "Lagos State Safety Commission",
//     description:""
//   },
//   {
//     id: 5,
//     title: "Occupational Safety and Health (OSH)",
//     date: "Nov 1, 2025 | 09:00 (UTC+01:00)",
//     location: "Landmark Centre | Virtual Event",
//     image: event5,
//     tag: "Hybrid",
//   },
//   {
//     id: 6,
//     title: "INTO THE NEW FUTURE",
//     date: "Mar 17, 2025 | 19:00 (UTC+01:00)",
//     location: "Virtual Seminar",
//     image: event6,
//     tag: "Virtual Seminar",
//   },
//   {
//     id: 7,
//     title: "Move Big 2025",
//     date: "May 11, 2025 | 09:00 (UTC+01:00)",
//     location: "Landmark Centre | Virtual Event",
//     image: event7,
//     tag: "Hybrid",
//   },
//   {
//     id: 8,
//     title: "MISS COSMO | FINALE",
//     date: "May 11, 2025 | 09:00 (UTC+01:00)",
//     location: "Landmark Centre | Virtual Event",
//     image: event8,
//     tag: "Hybrid",
//   },
// ];

// export const events = rawEvents.map((event) => ({
//   ...event,
//   ...formatEventDates(event.date),
// }));
